import React from "react";
import { Text, View, StyleSheet } from "@react-pdf/renderer";

const styles = StyleSheet.create({
    titleContainer: {
        marginTop: 50
    },
    reportTitle: {
        fontSize: 12,
        textAlign: 'center',
        textTransform: 'uppercase',
    }
});

const InvoiceThankYouMsg = () => (
    <View style={styles.titleContainer}>
        <Text style={styles.reportTitle}>*** Thanks ***</Text>
        <Text style={styles.reportTitle}>for being Chintamani Paving Customer :)</Text>
    </View>
);

export default InvoiceThankYouMsg;